import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  header: {
    marginBottom: indent / 4,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingRight: 96,
  },
  timestampContainer: {
    marginBottom: indent * 1.5,
  },
  headerAvatar: {
    marginRight: 10,
  },
  headerGreeting: {
    flex: 1,
    marginLeft: 10,
    flexShrink: 1,
    minWidth: 0,
  },
});
